import { useQuery } from '@tanstack/react-query';
import { apiRequests } from '../apiRequests.js';

export const useGetCurrencies = (count = 200) => {
  const { data, error, isLoading } = useQuery({
    queryKey: ['getCurrencies'],
    queryFn: () => apiRequests.currencies.get(count),
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return {
    data,
    error,
    isLoading,
  };
};
